export const MAX_LTV_EPSILON = 1e-6

/**
 * Safety buffer applied to max LTV for borrow calculations.
 * Accounts for oracle/indexer price discrepancies: the UI uses indexer prices
 * for liability valuation while on-chain liquidity checks use oracle prices.
 * A small price difference can cause the simulation to revert near the max LTV boundary.
 */
export const BORROW_LTV_SAFETY_FACTOR = 0.995
